// material-ui
import { useTheme } from '@mui/material/styles';
import { useState, useEffect } from 'react';
// import { useState } from 'react';
// import useConfig from 'hooks/useConfig';

import IconButton from 'components/@extended/IconButton';
import { useDispatch, useSelector } from 'react-redux';
import { openDrawer } from 'store/reducers/menu';

// assets
import { MenuFoldOutlined, MenuUnfoldOutlined, QuestionCircleOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import Profile from 'layout/MainLayout/Header/HeaderContent/Profile';
import SupportModal from 'components/SupportModal';
// import MobileSection from 'layout/MainLayout/Header/HeaderContent/MobileSection';

// material-ui
import { Button, Stack, Typography, useMediaQuery, List, ListItemButton, ListItem, Box, LinearProgress } from '@mui/material';

// project import

// assets
// import AnimateButton from 'components/@extended/AnimateButton';
import CircularWithLabel from 'components/@extended/progress/CircularWithLabel';
import useAuth from 'hooks/useAuth';
import Avatar from 'components/@extended/Avatar';
import avatar1 from 'assets/images/users/avatar-1.png';
// import BillingManagementButton from 'sections/premiumBlock/BillingManagementButton';
import { resetAllState } from 'store/reducers/actions';
import { useNavigate } from 'react-router-dom';

// import { useNavigate } from 'react-router-dom';

import { getCalApi } from '@calcom/embed-react';

const NavButton = () => {
  const [supportModalOpen, setSupportModalOpen] = useState(false);

  // const { logout } = useAuth();
  // const navigate = useNavigate();

  // const { miniDrawer } = useConfig();
  const menu = useSelector((state) => state.menu);
  const accountDetails = useSelector((state) => state.proAccountReducer);
  const { user, logout } = useAuth();
  const dispatch = useDispatch();
  const { drawerOpen } = menu;
  const theme = useTheme();
  // const iconBackColorOpen = theme.palette.mode === 'dark' ? 'grey.200' : 'grey.300';
  const iconBackColor = theme.palette.mode === 'dark' ? 'background.default' : 'grey.100';
  // const [open, setOpen] = useState(!miniDrawer || drawerOpen);
  // const matchesMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    dispatch(openDrawer({ drawerOpen: !drawerOpen }));
  };

  const handleSupportModalOpen = () => {
    setSupportModalOpen(true);
  };

  const handleSupportModalClose = () => {
    setSupportModalOpen(false);
  };

  // Add Cal.com initialization
  useEffect(() => {
    (async function () {
      const cal = await getCalApi({ namespace: 'enterprise-demo' });
      cal('ui', {
        cssVarsPerTheme: { light: { 'cal-brand': '#8f3ff9' }, dark: { 'cal-brand': '#8f3ff9' } },
        hideEventTypeDetails: false,
        layout: 'month_view'
      });
    })();
  }, []);

  return (
    <>
      <List sx={{ pl: drawerOpen ? 0 : 1.5, width: drawerOpen ? '200px' : '50px' }} dense>
        {!matchesXs &&
          (!drawerOpen ? (
            <Stack direction="column" spacing={1} sx={{ mb: 1 }}>
              <IconButton
                aria-label="open drawer"
                onClick={handleDrawerToggle}
                edge="start"
                color="secondary"
                size="medium"
                variant="light"
                sx={{ color: 'text.primary', bgcolor: iconBackColor, ml: 0, my: 2 }}
              >
                <MenuUnfoldOutlined />
              </IconButton>
              <IconButton
                aria-label="support"
                onClick={handleSupportModalOpen}
                edge="start"
                color="secondary"
                size="medium"
                variant="light"
                sx={{ color: 'text.primary', ml: 0, my: 2 }}
              >
                <QuestionCircleOutlined />
              </IconButton>
            </Stack>
          ) : (
            <>
              <ListItemButton
                aria-label="open drawer"
                // startIcon={<MenuFoldOutlined />}
                onClick={handleDrawerToggle}
                // edge="start"
                color="text.secondary"
                variant="light"
                sx={{
                  my: 1,
                  pl: 3,
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: 'inherit'
                }}
              >
                {' '}
                <MenuFoldOutlined />
                <Typography variant="body1" ml={2}>
                  Collapse
                </Typography>
              </ListItemButton>
              <ListItemButton
                aria-label="support"
                // startIcon={<QuestionCircleOutlined />}
                onClick={handleSupportModalOpen}
                // edge="start"
                color="text.secondary"
                variant="light"
                sx={{
                  my: 1,
                  pl: 3,
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: 'inherit'
                }}
              >
                {' '}
                <QuestionCircleOutlined />
                <Typography variant="body1" ml={2}>
                  Support
                </Typography>
              </ListItemButton>
            </>
          ))}

        {matchesXs && (
          <Box px={1.5} pb={1} pt={0.5}>
            <Stack direction="column" spacing={1.25}>
              {accountDetails && (
                <Box>
                  <Typography variant="body2" color="secondary" mb={0.25}>
                    {accountDetails.plan} Plan
                  </Typography>
                  <Typography variant="body2" mb={0.75}>
                    {accountDetails.remaining_credits} Credits left
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <LinearProgress
                      variant="determinate"
                      value={Math.min(
                        100,
                        Math.max(0, (accountDetails.remaining_credits / (accountDetails.monthly_credits || 1)) * 100)
                      )}
                      sx={{ flex: 1, height: 6, borderRadius: 3 }}
                    />
                    <Typography variant="caption" color="text.secondary">
                      {Math.round(
                        Math.min(100, Math.max(0, (accountDetails.remaining_credits / (accountDetails.monthly_credits || 1)) * 100))
                      )}%
                    </Typography>
                  </Box>
                </Box>
              )}

              <Stack direction="row" alignItems="center" spacing={1.25}>
                <Avatar alt="profile user" src={user?.avatar ? user?.avatar : avatar1} size="xs" />
                <Typography variant="subtitle2">
                  {user?.name && user.name.length > 20 ? `${user.name.slice(0, 20)}...` : user?.name}
                </Typography>
              </Stack>

              <ListItemButton component="a" href="/profiles/user/payment" aria-label="manage-account" sx={{ px: 0, py: 0.75 }}>
                <Stack direction="row" spacing={1.25} alignItems="center">
                  <SettingOutlined />
                  <Typography variant="body2" color="secondary">Manage Account</Typography>
                </Stack>
              </ListItemButton>

              <ListItemButton onClick={handleSupportModalOpen} aria-label="support" sx={{ px: 0, py: 0.75 }}>
                <Stack direction="row" spacing={1.25} alignItems="center">
                  <QuestionCircleOutlined />
                  <Typography variant="body2" color="secondary">Support</Typography>
                </Stack>
              </ListItemButton>

              <ListItemButton
                onClick={async () => {
                  try {
                    document.cookie = 'myAppWebsiteURL=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                    await logout();
                    navigate('/login', { state: { from: '' } });
                    dispatch(resetAllState());
                  } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error(e);
                  }
                }}
                aria-label="logout"
                sx={{ px: 0, py: 0.75 }}
              >
                <Stack direction="row" spacing={1.25} alignItems="center">
                  <LogoutOutlined />
                  <Typography variant="body2" color="secondary">Logout</Typography>
                </Stack>
              </ListItemButton>
            </Stack>
          </Box>
        )}

        {!matchesXs && drawerOpen && accountDetails ? (
          <>
            <ListItemButton target="_blank" href={'/pricing'}>
              <Stack direction="row" spacing={2}>
                <CircularWithLabel
                  size={34}
                  value={Math.round(
                    ((accountDetails.monthly_credits - accountDetails.remaining_credits) / accountDetails.monthly_credits) * 100
                  )}
                  color="primary"
                />
                <Stack direction="column" sx={{ minWidth: 0 }}>
                  <Typography variant="body2" sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {accountDetails.remaining_credits} Credits
                  </Typography>
                  <Typography variant="body2" color="secondary" mt={0} sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {accountDetails.plan + ' Plan'}
                  </Typography>
                </Stack>
              </Stack>
            </ListItemButton>
            {accountDetails.plan === 'Free' ? (
              <>
                <ListItem sx={{ pb: 0 }}>
                  <Button variant="contained" size="small" fullWidth target="_blank" href={'/pricing'} sx={{ mb: 2 }}>
                    Upgrade Plan
                  </Button>
                </ListItem>
                <ListItem sx={{ pt: 1 }}>
                  <Typography variant="caption" align="center" sx={{ width: '100%' }} color="secondary">
                    Need multiple accounts?
                  </Typography>
                </ListItem>
                <ListItem sx={{ pb: 2 }}>
                  <Button
                    variant="outlined"
                    fullWidth
                    size="small"
                    color="secondary"
                    data-cal-namespace="enterprise-demo"
                    data-cal-link="vlad-rimo-4hr6iy/15min"
                    data-cal-config={JSON.stringify({
                      name: user?.name,
                      email: user?.email,
                      layout: 'month_view'
                    })}
                  >
                    Contact Sales
                  </Button>
                </ListItem>
              </>
            ) : null}
          </>
        ) : null}

        <Box pl={drawerOpen ? 2 : 0}>{!matchesXs && <Profile />}</Box>
      </List>
      <SupportModal open={supportModalOpen} handleClose={handleSupportModalClose} />
    </>
  );
};

export default NavButton;
